// import { useEffect, useState } from "react";
// import { useLocation } from "react-router-dom";
// import "./single.scss";
// import Sidebar from "../../components/sidebar/Sidebar";
// import Navbar from "../../components/navbar/Navbar";
// import { Link } from "react-router-dom";
// import { serverUrl } from "../../temp";
// const TeacherAttendanceSingle = () => {
//   // Extracting teacher_attendanceId using regular expressions
//   const location = useLocation();
//   // const teacher_attendanceId = location.pathname.match(/\/class\/(\d+)/);
//   const teacher_attendanceId = location.pathname.match(
//     /\/teacher-attendance\/(\d+)/
//   )?.[1];
//   console.log(teacher_attendanceId);
//   const [teacher_attendance, setTeacher_attendance] = useState(null);
//   let [token] = useState(localStorage.getItem("token"));

//   const redirectToLogin = () => {
//     alert("Plaese Login first then you can access this page...");
//     window.location.href = "/"; // Replace "/login" with the actual login page path
//   };

//   const fetch_teacher_attendance = async () => {
//     try {
//       const response = await fetch(
//         `${serverUrl}/teacher_attendance/${teacher_attendanceId}`
//       );
//       // if (!response.ok) {
//       //     throw new Error('Failed to fetch class');
//       // }
//       const data = await response.json();
//       setTeacher_attendance(data);
//       localStorage.setItem("lformData", JSON.stringify(data));
//     } catch (error) {
//       console.error(error);
//     }
//   };

//   useEffect(() => {
//     if (teacher_attendanceId) {
//       fetch_teacher_attendance();
//     }
//   }, [teacher_attendanceId]);

//   return (
//     <>
//       {!token && redirectToLogin()}
//       {token && (
//         <div className="single">
//           <Sidebar />
//           <div className="singleContainer">
//             <Navbar />
//             <div className="top">
//               <div className="left">
//                 <h1 className="title">Teacher Slot Details</h1>
//                 <div className="details">
//                   <h1 className="itemTitle">{teacher_attendance?.data.date}</h1>
//                   <div className="detailItem">
//                     <span className="itemKey">Day: </span>
//                     <span className="itemValue">
//                       {teacher_attendance?.data.day}
//                     </span>
//                   </div>
//                   {/* <div className="detailItem">
//                                             <span className="itemKey">Center Id: </span>
//                                             <span className="itemValue">{teacher_attendance?.data.center_id}</span>
//                                         </div> */}
//                   <div className="detailItem">
//                     <span className="itemKey">Teacher: </span>
//                     <span className="itemValue">
//                       {teacher_attendance?.data.timetable_user_name}
//                     </span>
//                   </div>
//                   <div className="detailItem">
//                     <span className="itemKey">Subject: </span>
//                     <span className="itemValue">
//                       {teacher_attendance?.data.subject_name}
//                     </span>
//                   </div>
//                   <div className="detailItem">
//                     <span className="itemKey">Class: </span>
//                     <span className="itemValue">
//                       {teacher_attendance?.data.class_name}
//                     </span>
//                   </div>
//                   {/* <div className="detailItem">
//                                             <span className="itemKey">Time: </span>
//                                             <span className="itemValue">{teacher_attendance?.data.time}</span>
//                                         </div> */}
//                   <div className="detailItem">
//                     <span className="itemKey">Start Time: </span>
//                     <span className="itemValue">
//                       {teacher_attendance?.data.start_slot_time}
//                     </span>
//                   </div>
//                   <div className="detailItem">
//                     <span className="itemKey">End Time: </span>
//                     <span className="itemValue">
//                       {teacher_attendance?.data.end_slot_time}
//                     </span>
//                   </div>
//                   <div className="detailItem">
//                     <span className="itemKey">Teacher Status: </span>
//                     <span className="itemValue">
//                       {teacher_attendance?.data.teacher_status}
//                     </span>
//                   </div>
//                   <div className="detailItem">
//                     <span className="itemKey">Replaced Teacher: </span>
//                     <span className="itemValue">
//                       {teacher_attendance?.data.user_rep_name}
//                     </span>
//                   </div>
//                   <div className="detailItem">
//                     <span className="itemKey">Replaced Subject: </span>
//                     <span className="itemValue">
//                       {teacher_attendance?.data.subject_rep_name}
//                     </span>
//                   </div>
//                 </div>
//               </div>
//             </div>
//             {/* <div className="right">
//                     <Chart aspect={3 / 1} title="class Spending ( Last 6 Months)" />
//                 </div> */}
//           </div>
//           {/* <div className="bottom">
//                 <h1 className="title">Last Transactions</h1>
//                 <List />
//                 </div> */}
//         </div>
//       )}
//     </>
//   );
// };

// export default TeacherAttendanceSingle;

import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import { serverUrl } from "../../temp";

const TeacherAttendanceSingle = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const teacher_attendanceId = location.pathname.match(
    /\/teacher-attendance\/(\d+)/
  )?.[1];
  const [teacher_attendance, setTeacher_attendance] = useState(null);
  const [token] = useState(localStorage.getItem("token"));
  const [isLoading, setIsLoading] = useState(true);

  const redirectToLogin = () => {
    alert("Please login first to access this page...");
    window.location.href = "/";
  };

  const fetchTeacherAttendance = async () => {
    try {
      const response = await fetch(
        `${serverUrl}/teacher_attendance/${teacher_attendanceId}`
      );
      const data = await response.json();
      setTeacher_attendance(data);
      localStorage.setItem("teacherAttendanceData", JSON.stringify(data));
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (teacher_attendanceId) {
      fetchTeacherAttendance();
    }
  }, [teacher_attendanceId]);

  if (!token) {
    redirectToLogin();
    return null;
  }

  return (
    <div className="single">
      <Sidebar />
      <div className="singleContainer">
        <Navbar />
        <div className="top">
          <div className="left">
            <div className="flex justify-between items-center mb-4">
              <button
                onClick={() => navigate(-1)}
                className="px-3 py-1 text-sm bg-purple-100 text-purple-800 rounded-lg hover:bg-purple-200 transition-all border border-purple-200 flex items-center gap-1 shadow-sm hover:shadow-md"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-4 w-4"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M10 19l-7-7m0 0l7-7m-7 7h18"
                  />
                </svg>
                Back
              </button>
              <h1 className="title flex-1 text-center">Teacher Slot Details</h1>
              <div className="w-20"></div>
            </div>

            {isLoading ? (
              <div className="flex justify-center items-center h-64">
                <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-purple-500"></div>
              </div>
            ) : (
              <div className="space-y-6">
                {/* Teacher Attendance Header */}
                <div className="bg-white rounded-xl p-6 shadow-sm">
                  <div className="flex flex-col md:flex-row gap-6 items-center md:items-start">
                    {/* Teacher Icon */}
                    <div className="flex-shrink-0">
                      <div className="w-20 h-20 md:w-24 md:h-24 rounded-full bg-purple-100 flex items-center justify-center">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="h-10 w-10 text-purple-600"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                          />
                        </svg>
                      </div>
                    </div>

                    {/* Teacher Info */}
                    <div className="flex-1 text-center md:text-left">
                      <h1 className="text-2xl font-bold text-gray-800 mb-3">
                        {teacher_attendance?.data.teacher_name}
                      </h1>

                      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm">
                        {teacher_attendance?.data.date && (
                          <div className="bg-gray-50 rounded-lg p-3">
                            <span className="text-gray-500 block">Date:</span>
                            <span className="font-medium">
                              {teacher_attendance.data.date}
                            </span>
                          </div>
                        )}
                        {teacher_attendance?.data.day && (
                          <div className="bg-gray-50 rounded-lg p-3">
                            <span className="text-gray-500 block">Day:</span>
                            <span className="font-medium">
                              {teacher_attendance.data.day}
                            </span>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                {/* Class Information */}
                <div className="bg-white rounded-xl p-6 shadow-sm">
                  <h3 className="text-lg font-medium text-gray-800 mb-4 border-b pb-2">
                    Class Information
                  </h3>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    {teacher_attendance?.data.class_name && (
                      <div>
                        <label className="block text-sm text-gray-500 mb-2">
                          Class
                        </label>
                        <p className="text-gray-800 bg-gray-50 rounded-lg p-3">
                          {teacher_attendance.data.class_name}
                        </p>
                      </div>
                    )}

                    {teacher_attendance?.data.subject_name && (
                      <div>
                        <label className="block text-sm text-gray-500 mb-2">
                          Subject
                        </label>
                        <p className="text-gray-800 bg-gray-50 rounded-lg p-3">
                          {teacher_attendance.data.subject_name}
                        </p>
                      </div>
                    )}
                  </div>
                </div>

                {/* Time Slot */}
                <div className="bg-white rounded-xl p-6 shadow-sm">
                  <h3 className="text-lg font-medium text-gray-800 mb-4 border-b pb-2">
                    Time Slot
                  </h3>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    {teacher_attendance?.data.start_slot_time && (
                      <div>
                        <label className="block text-sm text-gray-500 mb-2">
                          Start Time
                        </label>
                        <p className="text-gray-800 bg-gray-50 rounded-lg p-3">
                          {teacher_attendance.data.start_slot_time}
                        </p>
                      </div>
                    )}

                    {teacher_attendance?.data.end_slot_time && (
                      <div>
                        <label className="block text-sm text-gray-500 mb-2">
                          End Time
                        </label>
                        <p className="text-gray-800 bg-gray-50 rounded-lg p-3">
                          {teacher_attendance.data.end_slot_time}
                        </p>
                      </div>
                    )}
                  </div>
                </div>

                {/* Replacement Information */}
                {(teacher_attendance?.data.user_rep_name ||
                  teacher_attendance?.data.subject_rep_name) && (
                  <div className="bg-white rounded-xl p-6 shadow-sm">
                    <h3 className="text-lg font-medium text-gray-800 mb-4 border-b pb-2">
                      Replacement Details
                    </h3>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                      {teacher_attendance?.data.user_rep_name && (
                        <div>
                          <label className="block text-sm text-gray-500 mb-2">
                            Replaced By
                          </label>
                          <p className="text-gray-800 bg-gray-50 rounded-lg p-3">
                            {teacher_attendance.data.user_rep_name}
                          </p>
                        </div>
                      )}

                      {teacher_attendance?.data.subject_rep_name && (
                        <div>
                          <label className="block text-sm text-gray-500 mb-2">
                            Replacement Subject
                          </label>
                          <p className="text-gray-800 bg-gray-50 rounded-lg p-3">
                            {teacher_attendance.data.subject_rep_name}
                          </p>
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TeacherAttendanceSingle;
